import logo from "../assets/logo.svg"

export const TITLE = "SynAir-G" ;

export const LOGO = <img src = {logo} width="70" height="70" alt={TITLE}></img>;